import _isEmpty from 'lodash/isEmpty'
import _flatten from 'lodash/flatten'
import { getProviderSlotDetails } from 'utils/getProviderSlotDetails'
import { TimeOfDay } from 'constants/common'

type ParseProviderDataWithSlotsParams = {
  providersList: Provider[]
  providerSlots: NormalizedProviderSchedule
  nextAvailabilityForProviders: NextAvailabilityMap
  startSlotDate: Date
  slotListLimit: number
  counselingTypedFilters: ProviderFilter[]
  slotsRowLimit: number
  error: Error
  areSlotsLoading: boolean
  timeOfDay?: TimeOfDay[]
  timeZone?: string
}

type ParseProviderDataWithSlotsReturn = {
  providerCardDetails: ProviderCardDetails[]
  countDetails: CountDetails
  slotDateData?: SlotDateType
  providerSlotData?: ProviderScheduleDetails
}

export const parseProviderDataWithSlots = ({
  providerSlots,
  providersList,
  nextAvailabilityForProviders,
  startSlotDate,
  slotListLimit,
  counselingTypedFilters,
  slotsRowLimit,
  error,
  areSlotsLoading,
  timeOfDay = [],
  timeZone,
}: ParseProviderDataWithSlotsParams): ParseProviderDataWithSlotsReturn => {
  const providerCardDetails = providersList.map((providerDetails) => {
    const areSlotsEmpty = _isEmpty(providerSlots[providerDetails.id])
    const nextAvailabilitySlot =
      nextAvailabilityForProviders?.[providerDetails.id] || null

    const providerSlotResults = getProviderSlotDetails(
      providerDetails,
      providerSlots,
      providerDetails.id,
      startSlotDate,
      slotListLimit,
      counselingTypedFilters,
      slotsRowLimit,
      timeOfDay,
      timeZone
    )

    return {
      error,
      providerDetails,
      areSlotsEmpty,
      areSlotsLoading,
      nextAvailabilitySlot,
      ...providerSlotResults,
    }
  })

  const provider_count = providerCardDetails.map((provider) => {
    return { [provider.providerDetails.id]: provider.count }
  })

  const slot_sum = providerCardDetails.reduce((acc, provider) => {
    return acc + provider.count
  }, 0)

  const next_available_slot_sum = providerCardDetails.reduce(
    (acc, provider) => {
      const firstAvailableDateSlot = _flatten(
        Object.values(provider.generatedSlots)
      ).find((date) => !!date)

      return firstAvailableDateSlot || provider.nextAvailabilitySlot
        ? acc + 1
        : acc
    },
    0
  )

  const countDetails = { slot_sum, provider_count, next_available_slot_sum }

  return { providerCardDetails, countDetails }
}
